import client_lookups from '@/assets/json/clientLookups.json'
import client_config from '@/assets/json/client_config.json'
import use148Actions from '@/composables/actions/use148Actions'
import use446Actions from '@/composables/actions/use446Actions'
import use714Actions from '@/composables/actions/use714Actions'
import use573Actions from '@/composables/actions/use573Actions'
import use561Actions from '@/composables/actions/use561Actions'
import use445Actions from '@/composables/actions/use445Actions'
import use140Actions from '@/composables/actions/use140Actions'
import use827Actions from '@/composables/actions/use827Actions'
import use162Actions from '@/composables/actions/use162Actions'
import use440Actions from '@/composables/actions/use440Actions'
import router from '@/router/'
import { useAuthStore } from '@/stores/auth'
import { useFormStore } from '@/stores/form'
import { useGlobalStore } from '@/stores/global'

import apiHelperService from '@/services'
import axiosInstance from '@/services'
import use57Actions from './use57Actions'
import use24Actions from './use24Actions'

const filterCenterId = (options) => {
  const formStore = useFormStore()
  if (options && options.length > 0) {
    if (formStore.draft.request.appointments) {
      formStore.form.setFieldValue('serviceCenterId', formStore.draft.request.appointments.centerId)
    }
  } else {
    formStore.form.setFieldValue('selectedAppointmentDate', null)
    formStore.form.setFieldValue('selectedStartEndTimes', null)
    formStore.form.setFieldValue('serviceCenterId', null)
  }
  return options
}

const filterNumberOfYearsList = (options) => {
  const formStore = useFormStore()
  if (options) {
    if (options >= 0) {
      formStore?.form?.setFieldValue?.('numberOfYears', options)

      formStore.extraMap.isNumberOfYearsDisabled = options.isNumberOfYearsDisabled
    }
  }
  return options.map((item) => {
    return {
      id: item,
      text: item
    }
  })
}

const filterNumberOfYears = (options) => {
  const formStore = useFormStore()
  const {
    relationships: { son, daughter },
    numberOfYears: { threeYear, fourYear }
  } = client_lookups

  if (options) {
    const { numberOfYearsList = [], isNumberOfYearsDisabled = false } = options
    formStore.extraMap.isNumberOfYearsDisabled = isNumberOfYearsDisabled
    if (
      numberOfYearsList.includes(threeYear || fourYear) &&
      [son, daughter].includes(formStore.draft.request.sponsorRelationshipId)
    ) {
      formStore.extraMap.isNumberOfYearsDisabled = false
    }
    if (numberOfYearsList.length >= 0) {
      formStore.extraMap.yearsOfResidency = numberOfYearsList
      return numberOfYearsList.map((item) => {
        return {
          id: item,
          text: item
        }
      })
    }
  }
}

function filterPersonSubCategory(options) {
  const formStore = useFormStore()
  const authStore = useAuthStore()

  const {
    ServiceTransactions: { decree28_PersonsWhoAreTalented },
    application: { establishment }
  } = client_lookups

  const {
    reasonsExceptedFromNominationRequest: exemptedReasons,
    exceptedOldNominationRequestIdsPersonsWhoAreTalented: oldExemptions,
    reasonsAllowedForEstablishmentInNominationRequest: allowedReasons
  } = client_config

  const { transactionReasonCategoryId } = formStore.form.values

  const {
    user: { applicationId }
  } = authStore

  const isEstablishmentUser = applicationId == establishment

  /**
   * if this has been a draft and is editing
   */
  if (formStore.draft?.isInCompleteDraftFlag) {
    // TODO: implement me
  }
  if (isEstablishmentUser) {
    // TODO: implement me
  }

  /**
   * filter out exemptions from the options list
   */
  options = options.filter((o) => {
    return exemptedReasons.includes(o.id) === false && oldExemptions.includes(o.id) === false
  })

  return options
}

/**
 * performs filtration of transaction reasons based on
 * OG source code. this filter works with multiple
 * golden residency services
 *
 * important: only use this filter for
 * lookup/GetTransactionReasonsByModuleParentReasonId
 */
function filterGoldenResidencyReasons(options) {
  const globalStore = useGlobalStore()
  const formStore = useFormStore()

  const {
    serviceConfig: { isGoldenVisa },
    serviceTransactionId
  } = globalStore.startedService

  const {
    ServiceTransactions: {
      decree28_PersonsWhoAreTalented,
      goldenResidencyVisaForHumanitarianPioneersIssue,
      goldenResidenceScientistsandSpecialists
    }
  } = client_lookups

  if (serviceTransactionId === decree28_PersonsWhoAreTalented) {
    let allowedReasons = [
      724, 555, 554, 910, 911, 783, 912, 913, 914, 915, 916, 917, 918, 919, 920, 921, 922, 941, 942,
      948, 954, 558
    ]

    if (formStore.draft?.isInCompleteDraftFlag) {
      allowedReasons = [
        777, 724, 555, 554, 910, 911, 783, 557, 726, 816, 912, 913, 914, 915, 916, 917, 918, 919,
        920, 921, 922, 941, 942, 943, 944, 945, 946, 947, 948, 949, 950, 951, 952, 953, 954, 959,
        960, 558, 552
      ]
    }

    options = options.filter((o) => allowedReasons.includes(o.id))
  }

  if (serviceTransactionId === goldenResidencyVisaForHumanitarianPioneersIssue) {
    const allowedReasons = [1088]
    options = options.filter((o) => allowedReasons.includes(o.id))
  }

  if (serviceTransactionId === goldenResidenceScientistsandSpecialists) {
    const allowedReasons = [
      1089, 1090, 1093, 1092, 1091, 1086, 1087, 1097, 1096, 1100, 1094, 1099, 1095, 1098
    ]

    options = options.filter((o) => allowedReasons.includes(o.id))
  }

  return options
}

function filterRefundReasons(options) {
  const {
    refundReasonCategories: { depositForFinesCategory }
  } = client_lookups
  return options.filter((o) => o.id != depositForFinesCategory)
}

function filterDepartments(options) {
  const {
    adminRegions: { dubai }
  } = client_lookups
  return options.filter((o) => o.administrativeRegionId != dubai)
}
// 693
async function setDefaultAdminiStrativeRegionId(options) {
  const formStore = useFormStore()

  const infoRes = await apiHelperService.get(`/api/individual/info`)
  const { defaultImmigrationDepartmentId } = infoRes
  const currentDepartment = options.find((item) => {
    return item.id === defaultImmigrationDepartmentId
  })
  const mainDepartmentId = currentDepartment?.administrativeRegionId

  // After filter options need set the value as default.
  setTimeout(() => {
    formStore.form.setFieldValue('mainDepartmentId', mainDepartmentId)
  }, 300)

  return [currentDepartment]
}

function setRelationship(options) {
  const globalStore = useGlobalStore()

  const { personUN, familyRelationship, wifeCityCode, wifeFamilySequency } =
    router.currentRoute.value.query

  const {
    serviceConfig: { isGoldenVisa },
    serviceTransactionId
  } = globalStore.startedService

  const {
    relationships: { parent, samePerson }
  } = client_lookups

  if (+familyRelationship === +parent) {
    // formStore.draft.request.lookupLocalRelationId = samePerson
    options = options.filter((o) => o.id == samePerson)
  } else {
    options = options.filter((o) => o.id == familyRelationship)
    // formStore.draft.request.lookupLocalRelationId = +familyRelationship
  }

  return options.map((e) => {
    return {
      ...e,
      label: e.localizedName,
      value: +e.code || e.id
    }
  })
}

function filterModules(options) {
  const {
    module: { residency, visa }
  } = client_lookups

  return options.filter((o) => [residency, visa].includes(o.id))
}

function filterOutGCC(options) {
  const {
    gccNationalityId: { saudi, kuwait, oman, qatar, bahrain, uae }
  } = client_lookups
  const gccCountries = [saudi, kuwait, oman, qatar, bahrain, uae]

  return options.filter((o) => gccCountries.includes(o.id) === false)
}

function filterOutUAE(options) {
  const {
    gccNationalityId: { uae }
  } = client_lookups

  return options.filter((o) => o.id != uae)
}

function fitlerRelationships(options) {
  return options.filter(
    (a) =>
      (router.currentRoute.value.params.serviceId != 838 &&
        a.id == client_lookups.relationships.wife) ||
      a.id == client_lookups.relationships.son ||
      a.id == client_lookups.relationships.daughter
  )
}

function filter762MaritalStatuses(options) {
  const formStore = useFormStore()
  const { oldMaritalStatusId } = formStore.draft.request
  const { Single, Divorced, Widowed, Married } = client_lookups.maritalStatuses
  try {
    if ([Single, Divorced, Widowed].includes(oldMaritalStatusId)) {
      return options.filter((a) => a.id == Married)
    }
    if (oldMaritalStatusId == Married) {
      return options.filter((a) => a.id == Divorced || a.id == Widowed)
    }
  } catch (error) {
    console.error('filter762MaritalStatuses', error)
  }
}

function filterMotherSponsor(options) {
  return options.filter((a) => a.genderId == 2)
}
function fetchSponsors(options) {
  return options
}
async function _getSponsorEmails() {
  const formStore = useFormStore()
  const res = await apiHelperService.get(
    `/api/individual/info/userInfoFromUDB/${formStore.form.values.selectedSponsor.unifiedNumber}`
  )
  const { emailAddress } = res
  formStore.form.setFieldValue('currentEmail', emailAddress)
}

// 714
function sponsoredUnifiedNumberChange(option) {
  const formStore = useFormStore()
  const { isLoginUserSelected, sponsoredUnifiedNumber } = formStore.form.values
  if (sponsoredUnifiedNumber && !isLoginUserSelected) {
    // nested object only can be set by this way can't use setValues
    const currentItem = option
    currentItem &&
      formStore.form.setFieldValue('selectedSponsor.englishName', currentItem.englishName)
    formStore.form.setFieldValue('selectedSponsor.arabicName', currentItem.arabicName)
    formStore.form.setFieldValue('selectedSponsor.unifiedNumber', currentItem.unifiedNumber)
    formStore.form.setFieldValue('selectedSponsor.identityNumber', currentItem.identityNumber)

    _getSponsorEmails()
  }
}

const immigrationDepartmentIdChange = (optionItem, options) => {
  const formStore = useFormStore()

  if (formStore.form.values.immigrationDepartmentId) {
    const currentItem = options.find((item) => {
      return item.id == formStore.form.values.immigrationDepartmentId
    })

    if (currentItem?.administrativeRegionId) {
      formStore.extraMap.administrativeRegionId = currentItem.administrativeRegionId
    }
  } else {
    formStore.extraMap.administrativeRegionId = null
  }
}
const filterHumanExceptionStatuses = (options) => {
  return options?.filter((p) => p.id != 3)
}
const filterHumanExceptionTypes = (options, action_params, newValueId) => {
  const {
    humanExceptionStatus: { OutsideCountry, NewBornInsideCountry }
  } = client_lookups
  if (newValueId == OutsideCountry) {
    return options?.filter((p) => p.id == 1)
  } else if (newValueId == NewBornInsideCountry) {
    return options
  }
  return options?.filter((p) => p.id != 3 && p.id != 22)
}
function filterEducationLevels(options, params) {
  const {
    educationLevelId: { bachoular, master, phd }
  } = client_lookups
  if ([979, 939, 941, 942].includes(+params?.serviceTransactionId)) {
    //typingCenter filter
    return options.filter((l) => [bachoular, master, phd].includes(l.id))
  }
  return options
}
const filterTransactionReason = async (options, params) => {
  const authStore = useAuthStore()
  const formStore = useFormStore()
  const {
    user: { applicationId }
  } = authStore
  if (params?.serviceTransactionId == 1090) {
    const {
      removeBanTransactionReasons: { investorOrPartner, samePerson, relative },
      application: { establishment },
      icaEstablishmentsApplicationId
    } = client_lookups
    if ([establishment, icaEstablishmentsApplicationId].includes(applicationId)) {
      return options.filter((o) => ![samePerson, relative].includes(o.id))
    }
    return options.filter((o) => o.id != investorOrPartner)
  }
  if (params?.serviceTransactionId == 401) {
    const {
      transactionReason: {
        newNationality,
        professionChange,
        passportInfoError,
        personalInfError,
        addressInfoError
      }
    } = client_lookups
    return options.filter((p) =>
      [
        newNationality,
        professionChange,
        passportInfoError,
        personalInfError,
        addressInfoError
      ].includes(p.id)
    )
  }
  if (params?.serviceTransactionId == 406) {
    const {
      transactionReasons: { divorced },
      transactionReason: { uponSponsorRequest }
    } = client_lookups
    return options.filter((p) => [uponSponsorRequest, divorced].includes(p.id))
  }
  if (params?.serviceTransactionId == 599) {
    //typingCenter filter
    const allowedReasonArr = [725, 727, 816, 933, 564, 562, 563, 926, 927, 939]
    return options.filter((p) => allowedReasonArr.includes(p.id))
  }
  if (params?.serviceTransactionId == 1113) {
    //typingCenter filter
    const allowedReasonArr = [
      1101, 1102, 1104, 1105, 1106, 1107, 1108, 1109, 1110, 1111, 1112, 1113, 1114, 1115
    ]
    return options.filter((c) => allowedReasonArr.includes(c.id))
  }
  if (params?.serviceTransactionId == 1112) {
    //typingCenter filter
    const allowedReasonArr = [1103]
    return options.filter((c) => allowedReasonArr.includes(c.id))
  }
  if (params?.serviceTransactionId == 635) {
    //typingCenter filter
    const allowedReason = [
      724, 555, 554, 910, 911, 783, 912, 913, 914, 915, 916, 917, 918, 919, 920, 921, 922, 941, 942,
      948, 954, 558
    ]
    return options.filter((c) => allowedReason.includes(c.id))
  }
  if (params?.serviceTransactionId == 1104) {
    //typingCenter filter
    const allowedReason = [
      1089, 1090, 1093, 1092, 1091, 1086, 1087, 1097, 1096, 1100, 1094, 1099, 1095, 1098
    ]
    return options.filter((c) => allowedReason.includes(c.id))
  }
  if (params?.serviceTransactionId == 1105) {
    //typingCenter filter
    const allowedReason = [1088]
    return options.filter((c) => allowedReason.includes(c.id))
  }
  if ([639, 753, 799].includes(+params?.serviceTransactionId)) {
    //typingCenter filter
    const res = await apiHelperService.get(
      `/api/lookup/GetTransactionReasonsByModuleParentReasonId`,
      {
        params: {
          serviceTransactionId: params?.serviceTransactionId,
          existInSetupFlag: 1
        }
      }
    )
    formStore.draft.request.transactionReasonId = res?.[0].id || null
    return (options = res || [])
  }
  return options
}

function transactionReason599Change() {
  const formStore = useFormStore()
  const globalStore = useGlobalStore()
  const { serviceTransactionId } = globalStore.startedService
  if (serviceTransactionId != 599) return
  const { talentedPeopleNotRequireWorkplace } = client_lookups
  const { transactionReasonId = '' } = formStore.form.values
  formStore.extraMap.showEstablishmentDetails = true
  if (talentedPeopleNotRequireWorkplace.includes(transactionReasonId)) {
    formStore.extraMap.showEstablishmentDetails = false
    formStore.draft.request = {
      ...formStore.draft.request,
      workPlaceEstablishmentNumber: null,
      workPlaceEstablishmentDepartmentId: null
    }
  }
}
async function setSponsorDepartment(options) {
  const authStore = useAuthStore()
  const formStore = useFormStore()

  if (!authStore.establishmentInfo) {
    await authStore.fetchEstablishmentInfo()
  }

  setTimeout(() => {
    formStore.form?.setFieldValue(
      'immigrationDepartmentId',
      authStore.establishmentInfo.departmentID
    )
  }, 300)

  return options
}

async function setNewSponsorDepartment(options) {
  const authStore = useAuthStore()
  const formStore = useFormStore()

  if (!authStore.establishmentInfo) {
    await authStore.fetchEstablishmentInfo()
  }

  setTimeout(() => {
    formStore.form.setFieldValue('sponsorDepartmentIdNew', authStore.establishmentInfo.departmentID)
  }, 300)

  return options
}

async function setNewSponsorType(options) {
  const authStore = useAuthStore()
  const formStore = useFormStore()

  if (!authStore.establishmentInfo) {
    await authStore.fetchEstablishmentInfo()
  }

  setTimeout(() => {
    formStore.form.setFieldValue('sponsorTypeIdNew', authStore.establishmentInfo.sponsorTypeID)
  }, 300)

  return options
}

async function filterRelations(options) {
  const formStore = useFormStore()
  const { serviceTransactionId } = formStore.extraMap
  const {
    relationships: { samePerson, parent }
  } = client_lookups
  if ([502, 556].includes(serviceTransactionId)) {
    return options.filter((e) => ![samePerson, parent].includes(e.id))
  }
  return options
}
async function onCountryOfBirthChange() {
  const formStore = useFormStore()
  formStore.draft.request = {
    ...formStore.draft.request,
    englishPlaceOfBirth: '',
    arabicPlaceOfBirth: ''
  }
  formStore.extraMap = {
    ...formStore.extraMap,
    isEnglishPlaceOfBirthDisabled: false,
    isArabicPlaceOfBirthDisabled: false
  }
}
async function filterContractTypes(options, { id_in }) {
  return options.filter((o) => id_in.includes(o.id))
}

async function getShipTripByShipNumber(selectedItem, options) {
  const formStore = useFormStore()

  Object.assign(formStore.draft.request, selectedItem)
  formStore.form.setValues(selectedItem)
}

/**
 * used for service 376
 */
async function checkRefundEligibility(options) {
  const globalStore = useGlobalStore()
  const formStore = useFormStore()
  const { serviceTransactionId } = globalStore.startedService
  const { referenceRequestNumber, refundTransactionReasonId, useFileNumber } = formStore.form.values

  const path = [
    '',
    'api',
    'refundRequest',
    serviceTransactionId,
    referenceRequestNumber,
    refundTransactionReasonId,
    0,
    'checkEligibilityForWhiteListRefund'
  ]

  const response = await axiosInstance.get(path.join('/'))

  formStore.extraMap.showRefundTable = !!useFileNumber

  const totalRefundableAmount = response
    .map((r) => r.totalRefundableAmount)
    .reduce((acc, amount) => acc + amount, 0)

  // needs actual response shape
}

async function goldenVisaAdminRegions(options) {
  const {
    adminRegions: { dubai }
  } = client_lookups

  return options.filter((o) => o.id != dubai)
}

async function setEstEconomicActivity(options) {
  const formStore = useFormStore()
  const { id, code } = options[0]
  const economicActObj = {
    economicActivityId: id,
    economicActivityCode: code
  }
  Object.assign(formStore.draft.request, economicActObj)
  formStore.form.setValues(economicActObj)
  return options.map((e) => {
    return {
      ...e,
      label: e.localizedName,
      value: +e.code || e.id
    }
  })
}

async function fetchNewProfessionOptions() {
  const formStore = useFormStore()
  const { professionId } = formStore.form.values
  let params = {
    id: professionId
  }
  let res = await apiHelperService.get('/api/lookup/profession', { params })
  return res || []
}
function filterReplacementTypesOptions(options) {
  const {
    replacementTypesEidaForResi: { changePassportForResidency }
  } = client_lookups
  return options.filter((r) => r.id != changePassportForResidency && r.id != 3)
}
function filter575RelationOptions(options) {
  return options.filter((item) => [1, 2, 3, 4, 68].includes(item.id))
}
function filterEducationLevelOptions(options) {
  const globalStore = useGlobalStore()
  const { serviceTransactionId } = globalStore.startedService
  if (serviceTransactionId == 739) {
    return options.filter((item) => item.id == 8)
  }
  return options
}

async function setGenderBasedOnRelationship() {
  const formStore = useFormStore()

  const { sponsorRelationshipId } = formStore.form.values

  const relationsPath = '/api/lookup/GetFamilyRelations'
  const storagePath = `${relationsPath}?${new URLSearchParams({}).toString()}`

  const relations = JSON.parse(sessionStorage.getItem(storagePath) || '{}')

  if (Object.keys(relations).length === 0) {
    const response = await axiosInstance.get(relationsPath)
    Object.assign(relations, response)
  }

  const relationObj = relations.find((r) => r.id == sponsorRelationshipId)

  if (!relationObj) return

  formStore.form.setFieldValue('genderId', relationObj.genderId)
}

async function filterNewResidencyType(options) {
  const {
    newResiType: {
      propertyOwner,
      foreignerRetired,
      virtualWork,
      divorcedAndWidowed,
      countriesOfDisastersAndWars,
      greenResidncy,
      goldenResidence
    }
  } = client_lookups

  return options.filter((o) =>
    [
      propertyOwner,
      foreignerRetired,
      virtualWork,
      divorcedAndWidowed,
      countriesOfDisastersAndWars,
      greenResidncy,
      goldenResidence
    ].includes(o.id)
  )
}

async function filterImmigrationDepartment(options) {
  const formStore = useFormStore()
  const globalStore = useGlobalStore()
  const { serviceTransactionId } = globalStore.startedService
  const { administrativeRegionId = '' } = router.currentRoute.value.query
  if ([411, 412, 564, 434, 435, 682, 683, 1120].includes(serviceTransactionId)) {
    const _options = options.filter((item) => item.administrativeRegionId == administrativeRegionId)
    formStore.form.setFieldValue('immigrationDepartmentId', _options?.[0]?.id)
    return _options
  }
  return options
}

function filterSponsorType(options) {
  return options.filter((item) => !item.isEstablishmentSponsor)
}
function filterRelationship(options) {
  return options.filter((e) => e.id != client_lookups.relationships.none)
}

function on945ReligionCHange(curItem) {
  const formStore = useFormStore()
  const { id = '' } = curItem || {}
  formStore.extraMap.isFaithRequired = id != 4
}

function on571WorkTypeChange() {
  const authStore = useAuthStore()
  if (!authStore.isUserEstablishment) return

  const formStore = useFormStore()
  const globalStore = useGlobalStore()
  const { workTypeId = '', companyName = '', individualInfo = {} } = formStore.form.values
  const {
    workTypes: { Private }
  } = client_lookups
  if (companyName) return

  if (workTypeId == Private) {
    formStore.draft.request.companyName =
      globalStore.languageId == 2 ? individualInfo.englishName : individualInfo.arabicName
  }
}

function filter572ReplacementTypes(options) {
  const {
    replacementTypesEidaForResi: { dataUpdate, changePassportForResidency }
  } = client_lookups
  return options.filter((e) => ![dataUpdate, changePassportForResidency].includes(e.id))
}
export default function () {
  return {
    filterPersonSubCategory,
    filterGoldenResidencyReasons,
    filterRefundReasons,
    filterDepartments,
    setRelationship,
    filterNumberOfYearsList,
    filterCenterId,
    checkPersonInfo: use446Actions().checkPersonInfo,
    economicActivityChange: use148Actions().economicActivityChange,
    establishmentPartnershipTypeIdChange: use148Actions().establishmentPartnershipTypeIdChange,
    immigrationDepartmentIdChange: immigrationDepartmentIdChange,
    filterModules,
    filterOutGCC,
    filterOutUAE,
    fitlerRelationships,
    filter762MaritalStatuses,
    setSponsorDepartment,
    setNewSponsorDepartment,
    setNewSponsorType,
    setDefaultAdminiStrativeRegionId,
    filterMotherSponsor,
    filterSponsor: (options) => use714Actions('filterSponsor', options),
    filterReplacementTypes: (options) => use561Actions('filterReplacementTypes', { options }),
    sponsoredUnifiedNumberChange,
    formatYears: (options) => {
      return options.map((o) => ({ id: o, text: o }))
    },
    filterHumanExceptionStatuses,
    filterHumanExceptionTypes,
    filterTransactionReason,
    onGccClassCodeChange: use573Actions().onGccClassCodeChange,
    getValidationMessage: use573Actions().getValidationMessage,
    loadAttachmentTypesByServiceId: use573Actions().loadAttachmentTypesByServiceId,
    setGccCategoryData: use573Actions().setGccCategoryData,
    setGccTypeData: use573Actions().setGccTypeData,
    setGccRelationData: use573Actions().setGccRelationData,
    setTypeId: use573Actions().setTypeId,
    filterContractTypes,
    getShipTripByShipNumber,
    checkRefundEligibility,
    fetchSponsors,
    filterNumberOfYears,
    filterRelations,
    onCountryOfBirthChange,
    transactionReasonChange: (params) => use445Actions('checkViolatedFiles', params),
    setEstEconomicActivity,
    fetchNewProfessionOptions,
    filterReplacementTypesOptions,
    filter575RelationOptions,
    filterEducationLevelOptions,
    goldenVisaAdminRegions,
    setGenderBasedOnRelationship,
    filterWorkSector: (options) => use140Actions('filterWorkSector', options),
    filterOtherCountryEmbassy: (options) => use827Actions('filterOtherCountryEmbassy', options),
    filterEstablishmentType: (options) => use140Actions('filterEstablishmentType', options),
    currentNationalityChange: (params) => use140Actions('currentNationalityChange', params),
    filterApplicationType: (options) => use148Actions().filterApplicationType(options),
    establishmentDepartmentChange: () => use162Actions('establishmentDepartmentChange'),
    ...use57Actions(),
    ...use24Actions(),
    filterNewResidencyType,
    filterImmigrationDepartment,
    getEstabFines: () => use440Actions('getEstabFines'),
    filterSponsorType,
    requestDetailsCurrentNationalityChange: (params) => {
      use446Actions().requestDetailsCurrentNationalityChange(params)
    },
    filterRelationship,
    transactionReason599Change,
    filterEducationLevels,
    on945ReligionCHange,
    on571WorkTypeChange,
    filter572ReplacementTypes
  }
}
